module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n';
 if (hasItems()) { 
__p+='\n\n	<div class="timeline" >\n		<div class="timeline__line"></div>\n		<div class=" js-timeline-sections">\n		</div>\n	</div>\n\n';
 } else if (!isLoading()) { 
__p+='\n\n	<div class="timeline__empty" >\n		<div class="timeline__empty-container">\n			<div class="empty-indicator">\n				<div class="empty-indicator__icon"></div>\n					<h2>'+
((__t=( obj.getEmptyTitle() ))==null?'':__t)+
'</h2>\n					<p>'+
((__t=( obj.getEmptySubTitle() ))==null?'':__t)+
'</p>\n				</div>\n			</div>\n	</div>\n\n';
 } 
__p+='\n\n<div class="timeline__loading" >\n	<div class="timeline__loading-container">\n		<div class="m-loader"></div>\n	</div>\n</div>\n\n<div class="schedule-footer">\n	';
 if (hasMoreItems()) { 
__p+='\n	<a class="m-btn js-next">load more items</a>\n	';
 } 
__p+='\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/components/timeline-view/templates/timeline-layout.html
// module id = 415
// module chunks = 0